/* import __COLOCATED_TEMPLATE__ from './sla-target-type-filter.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { REPORTING_FILTER_SELECT_ALL } from 'embercom/lib/reporting/flexible/constants';

export default class SlaTargetTypeFilter extends Component {
  @service appService;
  @service intercomEventService;
  @service intl;
  @tracked label = this.currentLabel;
  selectedDropdownItems = this.args.selected.values || [];

  get slaTargetTypeLabels() {
    let labels = {
      first_reply_time: this.intl.t(
        'components.reporting.custom.chart-builder.filter-bar.sla-target-type-filter.first-response-time',
      ),
      next_reply_time: this.intl.t(
        'components.reporting.custom.chart-builder.filter-bar.sla-target-type-filter.next-response-time',
      ),
      time_to_close: this.intl.t(
        'components.reporting.custom.chart-builder.filter-bar.sla-target-type-filter.time-to-close',
      ),
      resolution_time: this.intl.t(
        'components.reporting.custom.chart-builder.filter-bar.sla-target-type-filter.time-to-resolve',
      ),
    };

    if (this.appService?.app?.canUseFeature('inbox-sla-speed-of-answer')) {
      labels.speed_of_answer = this.intl.t(
        'components.reporting.custom.chart-builder.filter-bar.sla-target-type-filter.speed-of-answer',
      );
    }

    return labels;
  }

  get items() {
    return this.groupList;
  }

  get selectedStates() {
    return this.selectedDropdownItems.filter((item) => item !== REPORTING_FILTER_SELECT_ALL);
  }

  get allItems() {
    return Object.entries(this.slaTargetTypeLabels).map(([value, text]) => ({
      text,
      value,
      isSelected: this.selectedDropdownItems.includes(value),
    }));
  }

  get groupList() {
    return [
      {
        items: this.allItems,
      },
    ];
  }

  get currentLabel() {
    if (
      this.selectedDropdownItems?.length &&
      this.selectedDropdownItems[0] !== REPORTING_FILTER_SELECT_ALL
    ) {
      return this.selectedDropdownItems.map((value) => this.slaTargetTypeLabels[value]).join(', ');
    } else {
      return this.intl.t(
        'components.reporting.custom.chart-builder.filter-bar.sla-target-type-filter.any',
      );
    }
  }

  @action
  onClose() {
    if (this.isDestroying) {
      return;
    }

    if (!this.selectedDropdownItems.length) {
      this.selectedDropdownItems = [REPORTING_FILTER_SELECT_ALL];
    }

    this.intercomEventService.trackAnalyticsEvent({
      action: 'filtered_by_sla_target_type',
      object: this.args.analyticsObject,
      state: this.selectedStates,
    });

    this.args.setSelected(this.selectedDropdownItems);
    this.label = this.currentLabel;
  }

  @action
  removeFilter() {
    this.selectedDropdownItems = [];
    this.args.removeFilter();
  }
}
